export const WATERFORD_STUDENT = 'waterford-student';
export const WATERFORD_PARENT = 'waterford-parent';
export const WATERFORD_TEACHER = 'waterford-teacher';
